const { fetchSingle: fetchSingleSection } = window.BAO.sectionRenderer

class ProductCard extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupObservers()
    this.syncMediaToggle()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els.toggleMedia?.exists) return

    this.handleMediaToggle = this.handleMediaToggle.bind(this)
    this.listeners.add(
      window.BAO.eventBus,
      window.BAO.EVENTS.COLLECTION_MEDIA_TOGGLE.CHANGED,
      this.handleMediaToggle,
    )
  }

  handleMediaToggle (event) {
    this.mediaToggled = event.detail.isToggled
  }

  syncMediaToggle () {
    if (!this.els.toggleMedia?.exists) return
    if (!this.externalEls.mediaToggle?.exists) return

    this.mediaToggled =
      this.externalEls.mediaToggle.element.dataset.mediaToggled === 'true'
  }

  renderToggledMedia () {
    if (!this.els.toggleMedia?.exists) return

    const templateEl = this.els.toggleMedia.element
    if (!templateEl.content.childElementCount) return

    const mediaEl = templateEl.parentElement
    const currentMediaEls = [...mediaEl.children].filter(
      (childEl) => childEl !== templateEl,
    )

    mediaEl.insertBefore(templateEl.content, templateEl)
    templateEl.content.append(...currentMediaEls)
  }

  setupObservers () {
    if (!this.productUrl) return

    this.onEntry = this.onEntry.bind(this)

    this.observer = new IntersectionObserver(this.onEntry, {
      threshold: 0,
    })

    this.observer.observe(this)
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    observer.unobserve(this)

    this.fetchProductContent()
  }

  async fetchProductContent () {
    try {
      const response = await fetchSingleSection(
        'product-card-colors',
        this.productUrl,
      )

      const newDOM = window.BAO.sectionRenderer.convertToDOM(response)

      const coloursContent = newDOM.querySelector('.prd-CardColors')

      this.els.colors.element.innerHTML = coloursContent.outerHTML
    } catch (error) {
      console.error(error)
    }
  }

  get productUrl () {
    return this.dataset.productUrl || ''
  }

  get mediaToggled () {
    return this.dataset.mediaToggled === 'true'
  }

  set mediaToggled (value) {
    if (value === this.mediaToggled) return

    this.dataset.mediaToggled = value
    this.renderToggledMedia()
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard)
}
